import { CONFIG } from '@shared/environment/environment';
import { INSURER_CONFIG } from '@shared/insurer';
export function brandAsset(asset) {
    return `${CONFIG.apiUrl}/insurer/${INSURER_CONFIG.id}/${asset}`;
}
